import type { OptionType } from '../../types';

type MultiValueData = OptionType & {
  multiValueLabel?: React.ReactNode | string;
};

export const getMultiSelectDisplayLabel = (data: MultiValueData): React.ReactNode => {
  if (
    data &&
    data.multiValueLabel &&
    typeof data.multiValueLabel !== 'object'
  ) {
    return data.multiValueLabel;
  }
  if (data && typeof data.label === 'string') {
    return data.label;
  }
  if (data?.label && typeof data.label === 'object' && 'props' in data.label) {
    return (data.label as { props: { label?: React.ReactNode } }).props.label;
  }
  return undefined;
};